'use client';
import { useRouter } from 'next/navigation';
import { Box } from '@mui/material';

import { TradeButtons } from '@/components';
import { findMarket } from '@/utils';
import type { CardVariantProps } from './types';

import { ROUTES } from '@/constants';

export function SportsCard({ event }: CardVariantProps) {
  const router = useRouter();
  const gameUrl = event.gameId
    ? ROUTES.GAME_DETAIL(event?.homeTeam?.league || 'live', event?.id.toString())
    : null;
  function handleClick(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    e.stopPropagation();

    if (gameUrl) {
      router.push(gameUrl);
      return;
    }
  }

  const yesTeamName = event.homeTeam?.name || 'Team 1';
  const noTeamName = event.awayTeam?.name || 'Team 2';
  const yesTeamColor = event.homeTeam?.color;
  const noTeamColor = event.awayTeam?.color;

  const drawMarket = findMarket(event, 'draw');
  const hasDraw = !!drawMarket;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        mt: 'auto',
        gap: 2,
      }}
    >
      <TradeButtons
        onYesClick={handleClick}
        onNoClick={handleClick}
        onDrawClick={hasDraw ? handleClick : undefined}
        yesLabel={yesTeamName}
        noLabel={noTeamName}
        drawLabel={hasDraw ? 'DRAW' : undefined}
        yesColor={yesTeamColor}
        noColor={noTeamColor}
        truncateLabel={true}
      />
    </Box>
  );
}
